import { connect } from 'react-redux';
import React from 'react';
import axios from 'axios';

import Form from '../../../../components/Form/Form';
import Spinner from '../../../../components/Spinner';

import './styles.scss';

class Component extends React.Component {
  state = {
    form: {
      Hero: {},
      CTA: {},
    },
    error: {
      Hero: null,
      CTA: null,
    },
    submitting: {
      Hero: false,
      CTA: false,
    },
  }

  componentDidMount() {
    if (this.props.authenticatedID !== null) {
      window.location = '/advisor';
    }
  }

  RenderVideo = () => (
    <div className="wistia_responsive_padding" style={{ padding: "56.25% 0 0 0", position: "relative" }}>
      <div className="wistia_responsive_wrapper" style={{ height: "100%", left: "0", position: "absolute", top: "0", width: "100%" }}>
        <div className="wistia_embed wistia_async_azqbaslwwn videoFoam=true" style={{ height: "100%", position: "relative", width: "100%" }}>
          <div className="wistia_swatch" style={{ height: "100%", left: "0", opacity: "1", overflow: "hidden", position: "absolute", top: "0", transition: "opacity 200ms", width: "100%" }}>
            <img src="https://fast.wistia.com/embed/medias/azqbaslwwn/swatch" style={{ filter: "blur(5px)", height: "100%", objectFit: "contain", width: "100%" }} alt="" />
          </div>
        </div>
      </div>
    </div>
  )

  handleFormChange = Form => event => this.setState({
    form: {
      ...this.state.form,
      [Form]: {
        ...this.state.form[Form],
        ...event.target.value,
      }
    },
    error: {
      ...this.state.error,
      [Form]: null,
    },
  })

  handleFormSubmit = Form => () => {
    const FormData = this.state.form[Form];
    const isRequired = Key => Object.prototype.hasOwnProperty.call(FormData, Key) === false || FormData[Key].trim() === "";
    const setError = ErrorMsg => this.setState({
      error: {
        ...this.state.error,
        [Form]: ErrorMsg,
      }
    });

    if (isRequired('email')) {
      setError('Email is a required field');
      return;
    }

    if (isRequired('linkedin')) {
      setError('Linkedin username is a required field');
      return;
    }

    const Regx = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

    if (Regx.test(FormData['email']) === false) {
      setError('Please enter a valid email');
      return;
    }

    this.setState({
      submitting: {
        [Form]: true,
      }
    });

    axios.post('https://www.paragonone.com/advisor-apply', {
      email: FormData['email'],
      linkedin_username: FormData['linkedin'],
    })
      .then(response => {
        window.location = response.data.url;
      })
      .catch(err => this.setState({
        submitting: {
          [Form]: false,
        },
        error: {
          ...this.state.error,
          [Form]: err.toString(),
        }
      }));
  }

  getSSOLink = () => {
    return "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=78al7m56tam7os&redirect_uri=https%3A%2F%2Fapp.paragonone.com%2Fsignup%2Fauth%2Flinkedin&state=987654321&scope=r_basicprofile,r_emailaddress";
  }

  render() {
    return (
      <div className="AdvisorApply">
        <div className="AdvisorApply__Hero">
          <div className="container">
            <div className="AdvisorApply__Content">
              <h1>Give Back to the Community</h1>
              <div className="row">
                <div className="col Summary">
                  <p>Someone believed in you before even you did. Give back to the community, grow with your mentees, expand your network of like minded individuals by joining our elite group of advisors.</p>
                  <p>Join the movement to transform career education for students across the world.</p>
                </div>
                <div className="col">
                  <a className="LinkedInButton" href={this.getSSOLink()} />
                  <a className="AlreadyMember" href="/advisor">Already an advisor? Log in here</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="Section">
            <div className="ResponsiveVideo">
              {this.RenderVideo()}
            </div>
          </div>
          <div className="Section">
            <div className="row PerkCards">
              <div className="col-sm-4">
                <h4>Give Back</h4>
                <p>Pass on your expertise and experience to young minds who are eager for knowledge and success.</p>
              </div>
              <div className="col-sm-4">
                <h4>Expand Your Network</h4>
                <p>Join our community of advisors who are already contributing to our students and young professionals, and growing their sphere of influence. </p>
              </div>
              <div className="col-sm-4">
                <h4>Be a Leader</h4>
                <p>Share your story to inspire and encourage others through your mentorship and your coaching.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="AdvisorSignup__OurAdvisors">
          <div className="container">
            <img src="/images/advisors_community.jpg" alt="Our Advisors" />
          </div>
          <div className="IndustryHighlight">
            <div className="container">
              <h2 style={{ color: "#fff" }}>Our advisors come from</h2>
              <div className="row">
                <div className="col-sm-4">
                  <ul>
                    <li>Business</li>
                    <li>Marketing</li>
                    <li>Medicine</li>
                    <li>Entertainment</li>
                    <li>Real Estate</li>
                    <li>Food</li>
                  </ul>
                </div>
                <div className="col-sm-4">
                  <ul>
                    <li>Education</li>
                    <li>Government &amp; International Relations</li>
                    <li>Law</li>
                    <li>Finance</li>
                    <li>Fashion</li>
                    <li>Science, Engineering</li>
                  </ul>
                </div>
                <div className="col-sm-4">
                  <ul>
                    <li>Computers &amp; Software</li>
                    <li>Consulting</li>
                    <li>Visual Arts, Design, &amp; Architecture</li>
                    <li>Entrepreneurship</li>
                    <li>Hospitality</li>
                    <li>International Relations</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="Section">
            <div className="container">
              <h2>Frequently Asked Questions</h2>
              <div className="Question">
                <h6>What is Paragon One?</h6>
                <p>Paragon One is a career accelerator platform that pairs motivated college students and recent grads with working professionals to explore career opportunities and improve themselves.</p>
                <p>Click here to learn more about us. <a href="https://paragonone.com">https://paragonone.com</a></p>
              </div>

              <div className="Question">
                <h6>What will I be doing as an advisor?</h6>
                <p>As an advisor, you will be conducting online video coaching sessions for the students. Our system will match your expertise to students who will benefit from learning your insights and experiences.</p>
              </div>

              <div className="Question">
                <h6>Who will I be coaching?</h6>
                <p>Currently, we work primarily with college students but we are looking to expand to young working professionals.</p>
              </div>

              <div className="Question">
                <h6>How do you conduct coaching sessions?</h6>
                <p>All our sessions are done online over video with Zoom, a video software. You can conduct sessions from the comfort of your home or any location with internet connection.</p>
              </div>

              <div className="Question">
                <h6>What is the expected time commitment?</h6>
                <p>Typically, our advisors spend 3-4 hours per month coaching students. However, you could choose to spend less or more time, depending on your schedule.</p>
              </div>

              <div className="Question">
                <h6>Will I get paid?</h6>
                <p>Yes, advisors get paid on an hourly basis.</p>
              </div>
              <br />
              <p><b>More questions? Please email <a href="mailto:advisors@paragonone.com">advisors@paragonone.com</a></b></p>
            </div>
          </div>
        </div>
        <div className="FooterCTA">
          <div className="container">
            <div className="Section">
              <h3>Change student lives in a few hours</h3>
              <h2>BECOME A MENTOR NOW</h2>
              <a className="LinkedInButton" href={this.getSSOLink()}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

export default () => ({
  path: 'advisor-apply',
  component: connect(mapStateToProps)(Component),
});



// WEBPACK FOOTER //
// ./src/routes/signup/routes/AdvisorApply/index.js